<template>
    <section id="contact">
        <div class="row no-gutters">
            <div class="col-lg-6 col-md12 frame reddet">
                <div class="container">
                    <div class="row text-center align-items-center bordered-container">
                        <div class="col">
                            <h2>¿NECESITAS <br> AYUDA?</h2>
                            <hr class="light" data-aos="fade-right">
                            <h2>MESA DE CONTROL</h2>
                            <br>
                            <i class="fas fa-mobile-alt extra-big"></i>
                            <p class="big">
                                01 800 2889 353 <br>
                                <i class="fab fa-whatsapp"></i> 55 6675 0481
                            </p>
                            <br>
                            <i class="fas fa-envelope-square extra-big"></i>
                            <p class="big">
                                <a class="text-white" href="mailto:mesadecontrol@cosmic.com.mx">mesadecontrol@cosmic.com.mx</a>
                            </p>
                            <hr class="light" data-aos="fade-right">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md12">
                <a target="_blank" href="http://cfdicosmic.com.mx/">
                    <div id="cfdi">
                        <div class="row h-100 front" slot="front">
                           <div class="col-sm-12 my-auto">
                                <h2 class="text-center">Recibos CFDI</h2>
                           </div>
                        </div>
                    </div>
                </a>
                <div id="work">
                    <div class="row h-100 front">
                       <div class="col-sm-12 my-auto">
                            <h3 class="text-center">¿QUIERES TRABAJAR CON NOSOTROS?</h3>
                            <p class="text-center">
                                Consulta nuestra bolsa de trabajo <br>
                                01-800-28-89-353 <br>
                                o <br>
                                <a target="_blank" href="http://empleo.cosmic.mx"> http://empleo.cosmic.mx</a>
                            </p>
                       </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Work',
    components: {
    },
    data () {
        return {
            
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.big {
    font-size: 1em;
}
@media (min-width: 992px) {
  .big {
        font-size: 2em;
    }
}
.extra-big {
    font-size: 4.5em;
}
.frame {
    padding: 15px;
    max-height: 800px;
}

.bordered-container {
    border: 1px solid #fff;
    padding: 15px;
    height: 770px;
    color: #fff;
}
.bordered-container h1,
.bordered-container h2 {
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// resources/assets/vue/components/work/Work.vue